import axios from 'axios';
import moment from 'moment';
export const globalF = {
  methods: {
    validateToken: async function () {
      let user = this.$store.getters.getUser;
      if (user) {
        axios.defaults.headers.common['Authorization'] = `Basic ${user.email}`;
      }
      let userToken = this.$store.getters.getUserToken;
      return userToken;
    },
    getUrl() {
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      return url;
    },
    needRelogin: function (flag) {
      if (flag === 2) {
        this.goToLogin();
      }
    },
    goToLogin: function () {
      this.$store.commit('addUser', null);
      this.$store.commit('addUserBuilding', null);
      this.$emit('changePage', 'Login');
    },
    getGlobalData: function (listName) {
      let globalData = this.$store.getters.getGlobalData;
      let value = globalData[listName];
      if (listName === 'accessToken') {
        let accessTokenObj = JSON.parse(globalData[listName]);
        value = accessTokenObj.access_token;
      }
      return value;
    },
    getUnitsInformation: function (listName) {
      let obj = this.$store.getters.getUnitsInformation;
      return obj[listName];
    },
    getProspectsInformation: function (listName) {
      let obj = this.$store.getters.getProspectsInformation;
      return obj[listName];
    },
    getProspectsListWithStatus: function (listsObj) {
      let prospectsListWithStatus = [];
      if (listsObj.hasOwnProperty("prospects") && listsObj.hasOwnProperty("application")) {
        let prospects = listsObj.prospects;
        let applications = listsObj.application;
        let visitList = listsObj.visit;
        let prospectsUnits = listsObj.prospectUnits;
        let userNotification = this.getGlobalData("userNotification");

        let lg = this.$i18n.locale;

        prospects.map((p) => {

          let buildingObj = prospectsUnits.find(u => u.IdSession === p.IdSession);
          p.NOCIE = buildingObj.NOCIE;
          p.NODIV = buildingObj.NODIV;
          p.BuildingName = this.formatBuildingName(buildingObj);

          /* L'UNITÉ DOIT ÊTRE CHANGÉ. ELLE N'EST PLUS DISPONIBLE */
          if (buildingObj.Status === 4) {
            let un = userNotification.find(u => u.Id === 8);
            p.Creation = buildingObj.Creation;
            p.Status = lg === "fr" ? un.fr : un.en;
            p._cellVariants = { Status: un.color };
            p.Event = this.$t("label.unitNotAvailable");
          }

          else {

            let application = applications.find(a => a.IdSession === p.IdSession);

            if (application) {

              /* APPLICATIONS */

              let applicationsFollowUp = listsObj.applicationFollowUp;

              let applicationFollowUpList = applicationsFollowUp.filter(a => a.IdSession === p.IdSession);
              applicationFollowUpList.sort(function (a, b) {
                var dateA = new Date(a.Creation), dateB = new Date(b.Creation);
                return dateA - dateB;
              });

              let currentApplication = applicationFollowUpList.pop();

              if (currentApplication.UserNotification) {
                let un = userNotification.find(u => u.Id === currentApplication.UserNotification);
                p.Creation = currentApplication.Creation;
                p.Status = lg === "fr" ? un.fr : un.en;
                p._cellVariants = { Status: un.color };
                p.Event = un.Id === 6 ? this.$t("label.rentedReady") : this.formatTypes(3);
              }
            }

            else {

              /* VISITS */

              let visits = visitList.filter(v => v.IdSession === p.IdSession);

              if (visits.length > 0) {

                visits.sort(function (a, b) {
                  var dateA = new Date(a.Creation), dateB = new Date(b.Creation);
                  return dateB - dateA;
                });

                let currentVisit = visits.pop();

                let visitObj = this.formatVisit(currentVisit, userNotification, lg);

                p.Creation = currentVisit.Creation;
                p.Status = visitObj.value;
                p._cellVariants = { Status: visitObj.color };
                p.Event = visitObj.event;
              }

              else {

                /* NEW PROSPECT */
                let un = userNotification.find(u => u.Id === 1);

                p.Creation = p.SessionCreation;
                p.Status = lg === "fr" ? un.fr : un.en;
                p._cellVariants = { Status: un.color };
                p.Event = this.$t("label.newProspect");
              }
            }

          }
          return p;
        })

        prospectsListWithStatus = prospects;
      }

      prospectsListWithStatus.sort(function (a, b) {
        var dateA = new Date(a.Creation), dateB = new Date(b.Creation);
        return dateB - dateA;
      });

      return prospectsListWithStatus;
    },
    formatTypes: function (val) {
      let lg = this.$i18n.locale;
      let types = this.getGlobalData("types");
      let found = types.find(t => t.Id === val);
      return lg === 'fr' ? found.fr : found.en;
    },
    formatVisit: function (visite, userNotification, lg) {
      let v = {};
      v.creation = visite.StartDate;

      if (moment().isBefore(visite.EndDate)) {
        let un = userNotification.find(u => u.Id === 2);
        v.value = lg === "fr" ? un.fr : un.en;
        v.color = un.color;
        v.event = this.$t("label.visit");
      }
      else {
        let un = userNotification.find(u => u.Id === 3);
        v.value = lg === "fr" ? un.fr : un.en;
        v.color = un.color;
        v.event = this.$t("label.visitAfter");
      }

      return v;
    },
    formatBuildingName: function (value) {
      let displayname = "";
      if (value.NOCIE && value.NODIV) {
        let allbuildings = this.getGlobalData("buildings");
        let building = allbuildings.find(b => b.NOCIE === value.NOCIE && b.NODIV === value.NODIV);
        if (building) {
          displayname = building.hasOwnProperty('NOMDIV') ? building.NOMDIV : "";
        }
      }
      return displayname;
    },
    addSignatureToDoc: function (doc, imgExist, finalY) {
      for (let i = 0; i < imgExist.length; i++) {
        if (imgExist[i].hasOwnProperty("status")) {
          let status = imgExist[i].status;
          if (status === "fulfilled") {
            let img = new Image();
            let config = imgExist[i].value.config;
            if (config) {
              img.src = config.url;
              if (i === 0) {
                doc.addImage(img, 'PNG', 14, finalY, 55, 35);
              }
            }
          }
        }
      }
      return doc;
    },
    addImgToDoc: function (doc, imgExist, type) {
      for (let i = 0; i < imgExist.length; i++) {
        if (imgExist[i].hasOwnProperty("status")) {
          let status = imgExist[i].status;
          if (status === "fulfilled") {
            let img = new Image();
            let config = imgExist[i].value.config;
            if (config) {
              img.src = config.url;
              if (i === 0) {
                doc.addImage(img, 'PNG', 76, 7, 45, 25);
              }
              else if (i === 1) {
                if (type === 'vacancy') {
                  doc.addImage(img, 'PNG', 14, 38, 45, 25);
                }
                else {
                  doc.addImage(img, 'PNG', 128, 7, 45, 25);
                }
              }
              else if (i === 2) {
                if (type === 'vacancy') {
                  doc.addImage(img, 'PNG', 76, 38, 45, 25);
                }
                else {
                  doc.addImage(img, 'PNG', 180, 7, 45, 25);
                }
              }
              else {
                console.log("Img not supported");
              }
            }
          }
        }
      }
      return doc;
    },
    mapBuildingForSelect() {
      let buildings = this.getGlobalData("buildings");
    
      let mapBuilding = buildings.map(b => {
        return {
          text: b.NOMDIV,
          value: b
        }
      });

      mapBuilding.sort(function (a, b) {
        if (a.text < b.text) { return -1; }
        if (a.text > b.text) { return 1; }
        return 0;
      });

      mapBuilding.unshift({
        text: this.$t('label.properties'),
        value: null
      });

      return mapBuilding;
    },
    getAllDomains: function (token) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/domains`;
      axios
        .get(graphEndpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.allDomains = response.data.value;
        })
        .catch(() => {
          this.error = this.$t("info.errorgeneric");
          this.spinner = false;
        });
    },
    validateTenantDomain: function (email, allDomains) {
      if (email) {
        let ind = email.indexOf("@");
        let mailDomain = email.slice(ind+1);
        let find = allDomains.find(a => a.id === mailDomain);
        return find;
      }
      return false;
    },
    getAccessRole(page, role) {
      let accessRole = this.$store.getters.getAccessRole;
      let accessRolePage = accessRole[page];
      if (accessRolePage) {
        return accessRolePage.includes(role);
      }
      else {
        return role === 4;
      }
    },
    getDestinationByUserRole(role) {
      let taskEventDestination = this.getGlobalData("TaskEventDestination");
      let destination =  taskEventDestination.find(d => d.userRole === role);
      return destination ? destination.Id : 1;
    }
  }
};